import { useCmsContext } from "@rotorstudios/fe-cms";
import { useQuery } from "@tanstack/react-query";

import { useFetchCMSData } from "./useFetchCMSData";
import {
  CMS_DATASOURCES_VEHICLE_CARDS,
  CMS_DATA_SOURCES,
  CMS_SILOS,
  CMS_VEHICLE_ID,
} from "./static";
import type { IVehicleCard } from "../../uiModules/uiMVehicleSelector/components/VehicleCard";
import type { IVehicleFilter } from "../../uiModules/uiMVehicleSelector/components/VehicleFilter";

export type IVehicleCardsData = {
  vehicleCards: IVehicleCard[];
  vehicleFilters: IVehicleFilter[];
};

const useVehicleCardsData = (): IVehicleCardsData => {
  const { fetchData } = useFetchCMSData();
  const { fixVersionManifest } = useCmsContext();

  const path = fixVersionManifest?.[CMS_DATA_SOURCES]?.get(CMS_DATASOURCES_VEHICLE_CARDS);

  // *************************
  // Vehicles Data
  // *************************
  const getVehicleCardsDataSource = async (): Promise<any> => {
    const raw = await fetchData(path);

    if (raw?.data) {
      const manifestVehicles = new Set(
        [...fixVersionManifest[CMS_SILOS].values()].map(
          (silo: any) => silo[CMS_VEHICLE_ID],
        ),
      );

      // Only render vehicles that are in the manifest
      const vehicles = raw.data?.vehicles.filter((vehicle: IVehicleCard) =>
        manifestVehicles.has(vehicle.id),
      );

      return { ...raw.data, vehicles };
    }
  };

  const { data } = useQuery({
    queryKey: ["vehicleCards", path],
    queryFn: () => getVehicleCardsDataSource(),
    enabled: Boolean(path),
  });

  return {
    vehicleCards: data?.vehicles,
    vehicleFilters: data?.filters,
  };
};

export default useVehicleCardsData;
